/**
 * Area 3D extensions.
 * These extensions are specific to the 3D area and provide additional functionality, while many of rete-area-plugin's extensions are also available for this plugin.
 * @priority 7
 * @module Extensions
 */

export { animate } from './animate'
export * as forms from './forms'
export type { Params as LookAt } from './lookAt'
export { lookAt } from './lookAt'
